export interface IDriver {
  checkoutHour: number;
  checkoutDate: string;
  dateAndHour: string;
  vin: string; //faz sentido?
  advisorDriverName: string;
  advisorDriverImage: string;
  advisorDriverNationalId: string;
  vehiclePlate: string;
  vehicleModel: string;
}
